import {customAlphabet} from 'nanoid';
import config from "@/config";
import router from '@/router';
import storage from "@/utils/storage";
import Config from "@/config";
import {obtainClientId} from "@/utils/auth";
//import gettersRoute from "./getters-route";

const getters = {

    page(state) {
        return state.page;
    },

    windowHeight(state) {
        return state.windowHeight;
    },
    /*
    * isWindowXS работает только для моб экрана, остальные геттеры по нарастанию
    * */
    isWindowXS(state) {
        return state.isXS;//windowWidth < config.WIDTH_SM;
    },
    isWindowSM(state) {
        return state.isSM;//windowWidth >= config.WIDTH_SM;
    },
    isWindowMD(state) {
        return state.isMD;//windowWidth >= config.WIDTH_MD;
    },
    isWindowLG(state) {
        return state.isLG;//windowWidth >= config.WIDTH_LG;
    },
    isWindowXL(state) {
        return state.isXL;//windowWidth >= config.WIDTH_XL;
    },

    //...gettersRoute,

    /**
     * @deprecated - somehow is not reactive...
     * @param state
     * @param getters
     * @returns {any}
     */
    /*isRouteMy(state, getters) {
        const routeName = router.currentRoute.name;
        const routeParams = router.currentRoute.params;

        //console.log("routeName", routeName);

        const thisUserAuth = state.session.user?.id;
        return (routeName === "assignee" && thisUserAuth === routeParams.assigneeAuth)
            || (getters.isRouteAssigneeTask && thisUserAuth === routeParams.assigneeAuth)
            || getters.isRouteMyTask
            || getters.isRouteMyTaskNew
            || (routeName === "my" && !!thisUserAuth);
    },

    /!**
     * @deprecated
     * @param state
     * @param getters
     * @returns {any}
     *!/
    isRouteMyTask(state) {
        const routeName = router.currentRoute.name;
        const routeParams = router.currentRoute.params;

        const thisUserAuth = state.session.user?.id;
        return routeName === "my-todo" && !!thisUserAuth;
    },

    /!**
     * @deprecated
     * @param state
     * @param getters
     * @returns {any}
     *!/
    isRouteMyTaskNew(state) {
        const routeName = router.currentRoute.name;
        const routeParams = router.currentRoute.params;

        const thisUserAuth = state.session.user?.id;
        return routeName === "my-todo-new" && !!thisUserAuth;
    },

    /!**
     * @deprecated
     * @param state
     * @param getters
     * @returns {any}
     *!/
    isRouteAssigneeTask(state) {

    },*/

    clientAuth() {
        return obtainClientId();
    },

    /*isAuthedToGroup(state) {
        if (!state.session.user?.id) return false;

        //console.log(state.page['group']);

        const assignee = state.page['group']?.assignee
            || state.page['todo']?.assignee;
        if (assignee) return true;

        const group = state.page['group']?.group
            || state.page['todo']?.group;
        if (group) return state.session.userGroups?.findIndex(el => el.id === group.id) >= 0;

        return !!state.session.userGroups?.length;
    },*/
};
export default getters;
